export default "__VITE_ASSET__BE_Ywce8__"